export type { ConsumableOverviewProps } from './consumable-overview';
export * from './consumable-overview.routes';

export { default as ConsumableOverview, default } from './consumable-overview';
